import React from "react";
import { DROP_MENU_NAMES } from "../../content/index.content";
import { getTrueClasses } from "../../../../../helpers";
import Tools from "../Tools";
import Videos from "../Videos";
import "./index.scss";

const DropMenu = ({ menu }) => (
  <div
    className={getTrueClasses(
      "GCL-H-P-DM",
      menu === DROP_MENU_NAMES.tools && "GCL-H-P-DM_tools",
      menu === DROP_MENU_NAMES.videos && "GCL-H-P-DM_videos"
    )}
  >
    {menu === DROP_MENU_NAMES.tools ? <Tools /> : null}
    {menu === DROP_MENU_NAMES.videos ? <Videos /> : null}
  </div>
);

export default DropMenu;
